import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import React from "react";
import AccountSetting from "./tabs/Account Setting";
// import DataUpdate from "./tabs/DataUpdate";
import HR from "./tabs/HR";
import Tray from "./tabs/tray";
import UserManagement from "./tabs/UserManagement";
export default function LabTabs() {
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      <Box sx={{ flexGrow: 0 }}>
        <Grid item xs={12} md={12}>
          <TabContext value={value}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              style={{marginTop:'3rem', }}
            >     
              <Tab label="Account" value="1" />
              <Tab label="Users" value="2" />
              <Tab label="HR" value="3" />
              <Tab label="Tray" value="4" />
            </TabList>

            <TabPanel value="1">
              <AccountSetting />
            </TabPanel>
            <TabPanel value="2">
              <UserManagement />
            </TabPanel>
            <TabPanel value="3">
              <HR />
            </TabPanel>
            <TabPanel value="4">
              <Tray />
            </TabPanel>
          </TabContext>
        </Grid>
      </Box>
    </div>
  );
}
